:host {
  display: inline-flex;
  align-items: center;
  gap: var(--spacer-1);
}
:host aha-datepicker {
  height: inherit;
  width: 100%;
  flex: 1 1;
}
:host .aha-datepicker-range__button {
  display: flex;
  height: 100%;
}
